import React from 'react';
import { Field } from 'formik';

import styles from './academicPerformanceFormStyles';

import InputField from 'buyside/components/presentation/Form/Field/InputField/inputField';
import FileField from 'buyside/components/presentation/Form/Field/FileField/fileField';
import AddRemoveForm from 'buyside/components/presentation/Form/AddRemoveForm/addRemoveForm';

const { profileTestNames, satMaxes, gpaMaxes } = require('buyside/util/constantsFromRails.json');

// NOTE: make sure to update the appropriate schema in util/userProfileShowPageValidationSchemata

const AcademicPerformanceForm = () => {
  const renderTestResult = (testResultPath, testResult) => {
    const isSAT = testResult.name === 'SAT';
    const isGPA = testResult.name === 'GPA';
    return (
      <div>
        <div className={styles.testResultRow}>
          <div className={styles.testResultColumn}>
            <Field
              component={InputField}
              name={testResultPath + '.name'}
              type="select"
              label="Type"
              options={profileTestNames}
            />
          </div>
        </div>
        <div className={styles.testResultRow}>
          <div className={styles.testResultColumn}>
            <Field component={InputField} name={testResultPath + '.score'} label="Score" />
          </div>
          {(isSAT || isGPA) && (
            <div className={styles.testResultColumn}>
              <Field
                component={InputField}
                name={testResultPath + '.maxScore'}
                type="select"
                label="Out Of"
                options={isSAT ? satMaxes : gpaMaxes}
              />
            </div>
          )}
        </div>
        <div className={styles.testResultRow}>
          <div className={styles.testResultColumn}>
            <Field
              component={InputField}
              name={testResultPath + '.date'}
              type="date"
              label="Date"
            />
          </div>
        </div>
        {!testResult.currentStudent && (
          <Field
            component={FileField}
            name={testResultPath}
            label={`${isGPA ? 'Transcript' : 'Score Report'} (Optional)`}
            filefieldConfig={{ 'application/pdf': ['.pdf'] }}
          />
        )}
      </div>
    );
  };

  return (
    <AddRemoveForm
      title="Academic Results"
      attr="userProfile.profileTestResults"
      renderItem={renderTestResult}
      itemName="Academic Result"
      blankItem={{
        name: '',
        score: '',
        maxScore: '',
        date: null,
        filename: ''
      }}
    />
  );
};

export default AcademicPerformanceForm;
